import * as React from "react";
import { useActiveTimeFilters } from "../../../../../hooks/v3/hooks/use-active-time-filters.js";
import { useAppointmentContext } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
const useResetUiStateForNewDateStoreOrTimeFilters = (resetUiState, selectedDate) => {
  const [{ getAvailabilityTimeFilters }] = useActiveTimeFilters();
  const [, { store }] = useAppointmentContext();
  const previousSelectedDate = React.useRef();
  const previousSelectedStore = React.useRef();
  const previousSelectedFilters = React.useRef();
  React.useEffect(() => {
    const selectedDateChanged = previousSelectedDate.current !== selectedDate;
    const selectedStoreChanged = previousSelectedStore.current !== store?.globalStoreId;
    const { startTime, endTime } = getAvailabilityTimeFilters(selectedDate);
    const selectedFiltersChanged = previousSelectedFilters.current?.startTime?.toISOString() !== startTime?.toISOString() || previousSelectedFilters.current?.endTime?.toISOString() !== endTime?.toISOString();
    if (selectedDateChanged || selectedStoreChanged || selectedFiltersChanged) {
      previousSelectedDate.current = selectedDate;
      previousSelectedStore.current = store?.globalStoreId;
      previousSelectedFilters.current = { startTime, endTime };
      resetUiState();
    }
  }, [getAvailabilityTimeFilters, resetUiState, selectedDate, store]);
};
export {
  useResetUiStateForNewDateStoreOrTimeFilters as default
};
//# sourceMappingURL=useResetUiStateForNewDateStoreOrTimeFilters.js.map
